<template>
  <div>
    <v-dialog max-width="400px" scrollable v-model="dialogItem">
      <template v-slot:activator="{ on }">
        <v-btn @click="addItem()" color="primary" dark v-on="on">Create</v-btn>
      </template>
      <v-card>
        <!-- <v-card-title>
          <h1 class="title head-page">Counsulting Topic</h1>
        </v-card-title>-->
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout align-center justify-center row wrap>
              <v-flex xs12>
                <v-text-field clearable label="Name" v-model="formData.name"></v-text-field>
                <v-text-field clearable label="Hashtag" v-model="formData.hashtag"></v-text-field>
                <v-text-field clearable label="Keyword" v-model="formData.keyword"></v-text-field>
                <v-textarea
                  clearable
                  label="Description"
                  v-model="formData.description"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <base-delete-button :idx="formData.idx" module="ShopEdition"></base-delete-button>
          <v-spacer></v-spacer>
          <v-btn @click.stop="dialogItem = !dialogItem" color dark>Close</v-btn>
          <v-btn @click.prevent="doSubmit()" color="green" dark :loading="dialogLoading"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'dialog',
  data() {
    return {
      formData: [],
      dialogLoading: false
    }
  },
  watch: {
    dialogItem() {
      if (this.$store.state.ShopEdition.idx) {
        this.formData = this.$store.getters['ShopEdition/getAll'].filter(
          item => item.idx == this.$store.state.ShopEdition.idx
        )[0]
      } else {
        this.formData = []
      }
    }
  },
  computed: {
    dialogItem: {
      // getter
      get() {
        return this.$store.state.ShopEdition.dialog
      },
      // setter
      set(newValue) {
        this.$store.commit('ShopEdition/UPDATE_DIALOG', newValue)
      }
    }
  },
  created() {},
  methods: {
    async doSubmit() {
      try {
        const validate = await this.$validator.validateAll()
        if (validate) {
          this.dialogLoading = !this.dialogLoading
          const data = {
            ...this.formData
          }
          await this.$store.dispatch(`ShopEdition/insert`, data)
          this.$store.commit(`ShopEdition/UPDATE_DIALOG`, false)
          this.formData = []
          this.dialogLoading = !this.dialogLoading
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    addItem() {
      this.$store.commit('ShopEdition/UPDATE_DIALOG', true)
      this.$store.commit('ShopEdition/SET_IDX', null)
    }
  }
}
</script>

<style lang="scss" scoped></style>
